import "react-native-reanimated";
import "react-native-gesture-handler";
import { StatusBar, Text, View } from "react-native";
import { useFonts } from "expo-font";
import { NavigationContainer, NavigationContainerRef, useNavigation } from "@react-navigation/native";
import { Platform } from "react-native";
import { Provider as ReduxProvider } from "react-redux";
import { SafeAreaProvider } from "react-native-safe-area-context";
import * as Linking from 'expo-linking';
import * as Notifications from 'expo-notifications';
import { PersistGate } from "redux-persist/integration/react";
import {
  RootState,
  dispatch,
  persistor,
  store,
  useSelector,
} from "./redux/store";
import RootNavigation from "./navigation/RootNavigation";
import AuthNavigationScreens from "./navigation/AuthNavigation";
import ProfileNavigationScreens from "./navigation/ProfileNavigation";
import { createRef, useEffect, useState } from "react";
import { setLoggedOut } from "./redux/auth/authSlice";
import SplashScreen from "./screens/OnBoarding/OnBoardingScreens/Splash";

const images = [
  require("./assets/SplashImage/img1.png"),
  require("./assets/SplashImage/img2.png"),
  require("./assets/SplashImage/img3.png"),
  require("./assets/SplashImage/img4.png"),
  require("./assets/SplashImage/img5.png"),
  require("./assets/SplashImage/img6.png"),
];

Notifications.setNotificationHandler({
  handleNotification: async () => {
    return {
      shouldShowAlert: true,
      shouldPlaySound: true,
      shouldSetBadge: true,
    };
  },
});

export const navigationRef = createRef<NavigationContainerRef<any>>();


export default function AppWrapper() {
  const [expoPushToken, setExpoPushToken] = useState<string | undefined>();
  const [inAppNotification, setInAppNotification] = useState<Notification | null>(null);

  const url = Linking.useURL();
  const handleURL = (url: any) => {
      const { hostname, path, queryParams } = Linking.parse(url);
      if (path === 'experience/') {
        navigationRef.current?.navigate('experience', queryParams);
      } else {
        console.log(path, queryParams);
      }
  }

  useEffect(() => {
      if (url) {
          handleURL(url);
      } else {
          console.log('No URL');
      }
  }, [url])


  return (
    <>
      {Platform.OS === "web" ? (
        <View
          style={{
            width: "100%",
            maxWidth: 450,
            marginHorizontal: "auto",
            ...Platform.select({
              web: {
                overflow: "hidden",
                overscrollBehaviorY: "none",
              },
            }),
          }}
        >
          <ReduxProvider store={store}>
            <PersistGate loading={null} persistor={persistor}>
              <App />
            </PersistGate>
          </ReduxProvider>
        </View>
      ) : (
        <ReduxProvider store={store}>
          <PersistGate loading={null} persistor={persistor}>
            <App />
          </PersistGate>
        </ReduxProvider>
      )}
    </>
  );
}

const prefix = Linking.createURL("/")

const linking: any = {
  // add com.spark.love
  prefixes: ["spark://**",prefix,"https://spark.love/spark"],
  config: {
    // screens: {
    //   experience: 'experience/:_id',
    //   Discover: 'discover'
    // },
  },
};

function App() {
  const { loggedIn, isNewUser, isFirstLaunch } = useSelector((state: RootState) => state.user);
  const [data, setData] = useState(null)
  
  // useEffect(() => {
  //   dispatch(setLoggedOut());
  // }, [loggedIn]);

  // useEffect(()=>{
  //   Linking.getInitialURL()
  // })

  


  const [fontsLoaded] = useFonts({
    EBGaramondBold: require("./assets/fonts/EBGaramond-Bold.ttf"),
    EBGaramondRegular: require("./assets/fonts/EBGaramond-Regular.ttf"),
    EBGaramondMedium: require("./assets/fonts/EBGaramond-Medium.ttf"),
    EBGaramondSemiBold: require("./assets/fonts/EBGaramond-SemiBold.ttf"),
    EBGaramondExtraBold: require("./assets/fonts/EBGaramond-ExtraBold.ttf"),
    InterBold: require("./assets/fonts/Inter-Bold.ttf"),
    InterRegular: require("./assets/fonts/Inter-Regular.ttf"),
    InterMedium: require("./assets/fonts/Inter-Medium.ttf"),
    InterSemiBold: require("./assets/fonts/Inter-SemiBold.ttf"),
    InterExtraBold: require("./assets/fonts/Inter-ExtraBold.ttf"),
  });

  if (!fontsLoaded) {
    return null; // or a loading indicator
  }

  return (
    <SafeAreaProvider>
      <NavigationContainer ref={navigationRef}  linking={linking}>
        {isFirstLaunch ? <SplashScreen images={images}  /> :
          <>
            {loggedIn ? (
              !isNewUser ? (
                <RootNavigation />
              ) : (
                <ProfileNavigationScreens />
              )
            ) : (
              <AuthNavigationScreens />
            )}
          </>}
      </NavigationContainer>
    </SafeAreaProvider>
  );
}
